// extracted by mini-css-extract-plugin
export default {"headerTitle":"parsers_headerTitle__Vk3W1","page":"parsers_page__RA3s-","header":"parsers_header__dn5tl"};